import { useContext, useState, useEffect, useRef } from 'react';

import { GlobalContext } from "../../contexts/globalContext";

import styles from './StationListComponent.module.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

import Lottie from 'react-lottie-player';
import startAnimation from '../../graphics/conferenceScreen/power-on-anim.json'


const StationListComponent = ({ onlineDevices, onDeskClicked, setAllDeskIdsInRoom, deviceToStart, desksIdsForAnim, setDesksIdsForAnim, setPowerOnAllFlashing, powerOnAllRef }) => {

    const { deskData, socketRef } = useContext(GlobalContext);

    const [room, setRoom] = useState();
    const [devicesToStart, setDevicesToStart] = useState([]);

    const desksIdsForAnimRef = useRef(desksIdsForAnim);


    useEffect(() => {
        socketRef.current.emit('GET_ROOM_BY_ID', deskData.room._id, room => {

            if (room) {
                let allDesks = [...room.desks_south, ...room.desks_north, ...room.desks_east, ...room.desks_west]

                setAllDeskIdsInRoom(allDesks);

                room.allDesks = allDesks.sort((desk1, desk2) => desk1.number - desk2.number);
                setRoom(room)
            }

        })

    }, [])

    useEffect(() => {

        devicesToStart.forEach(element => {
            if (onlineDevices.includes(element)) {
                setDevicesToStart(devices => devices.filter(a => a !== element));
            }
        });

    }, [onlineDevices])

    useEffect(() => {
        if (deviceToStart) {
            setDevicesToStart([...devicesToStart, deviceToStart]);
        }
    }, [deviceToStart])

    useEffect(() => {

        let lastDeskAdded = desksIdsForAnim[desksIdsForAnim.length - 1]

        desksIdsForAnimRef.current = desksIdsForAnim

        if (lastDeskAdded) {
            setTimeout(() => {
                setDesksIdsForAnim(desksIdsForAnimRef.current.filter(a => a !== lastDeskAdded));
                if (desksIdsForAnimRef.current?.length === 0) {
                    setPowerOnAllFlashing(false)
                    powerOnAllRef.current.className = styles.on;
                }
            }, 20000)
        }

    }, [desksIdsForAnim])


    return (
        <div className={styles.list}>
            {room && room.allDesks.map((desk) => {
                let deskState = onlineDevices.find(
                    (deviceId) => deviceId === desk.deviceId
                );

                let currentDevice = deskData._id === desk._id

                return (<div key={desk._id} className={styles.station} style={{
                    borderLeft: currentDevice ? "12px solid #33FFC8" : "",
                    boxShadow: currentDevice ? "inset 10px 0px 10px -10px #33FFC8" : "",
                    color: currentDevice ? "#33FFC8" : deskState ? "#FFFFFF" : "#726FA8"
                }}>
                    <div className={styles.left}>
                        <span className={desksIdsForAnim.includes(desk._id) && !currentDevice && !deskState ? styles.colorCycle : ""}>
                            STATION {desk.number < 10 ? "0" : ""}{desk.number}
                        </span>
                        {currentDevice && <div className={styles.yourStation}>
                            <svg id="line" width="10" height="30" >
                                <line x1="0" y1="0" x2="0" y2="30" style={{ stroke: "#726FA8", strokeWidth: 5 }}></line>
                            </svg>
                            <FontAwesomeIcon className={styles.iconSmall} icon={byPrefixAndName.fas['microphone-stand']} />

                            YOUR STATION
                        </div>}
                    </div>
                    <div className={styles.buttonOnOff} onClick={() => {
                        onDeskClicked(desk.deviceId, deskState, currentDevice)
                        if (!deskState) {
                            if (!desksIdsForAnim.find(id => id === desk._id))
                                setDesksIdsForAnim((desksId) => [...desksId, desk._id])
                        } else {
                            let filteredDesksIds = desksIdsForAnim.filter(id => id !== desk._id)
                            setDesksIdsForAnim(filteredDesksIds)
                        }
                    }}
                        style={{ color: "#FFFFFF" }}
                    >
                        <span className={(!currentDevice && !deskState && desksIdsForAnim.includes(desk._id)) ? styles.colorCycle : ""}>
                            {currentDevice || deskState ? "SHUT DOWN" : "POWER ON"}
                        </span>
                        {(currentDevice || deskState) &&
                            <FontAwesomeIcon className={styles.icon} style={{ color: "#33FFC8" }} icon={byPrefixAndName.fas['power-off']} />
                        }
                        {!currentDevice && !deskState &&
                            <FontAwesomeIcon className={styles.icon} style={{ color: desksIdsForAnim.find(id => id === desk._id) ? "transparent" : "#726FA8" }}
                                icon={byPrefixAndName.fas['power-off']} />
                        }
                        {/* {currentDevice && <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fas['microphone-stand']} />} */}
                        {!currentDevice && !deskState && desksIdsForAnim.find(id => id === desk._id) && <Lottie
                            loop={true}
                            play={true}
                            animationData={startAnimation}
                            style={{ width: 71, height: 71, marginLeft: 20, position: "absolute", right: 19 }}
                        />}
                    </div>
                </div>)
            })}

        </div>
    );
}

export default StationListComponent;
